var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_holder home"},[_c('div',{staticClass:"content_holder"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.$t('main.home_title', {name: 'Uros'})))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }